import React from "react";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsConfiguration from "../generic-nav-bar/NavbarIconsConfiguration";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import { schemaValidateConfigurationsList } from "../../app/data/schemaValidateConfigurationsList";
import ViewLabel from "../generic-component/ViewLabel";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewCatalogLocationGeneric from "../generic-component/NewCatalogLocationGeneric";
import { configurationStartRegister } from "../../app/actions/configurationActions";
import { useNavigate } from "react-router-dom";

const ID_FORM = "admin-configuration";
const OPERATION = "register";

const NewConfigurations = () => {
  debugLogPages(':: NewConfigurations'); 

    const navigate = useNavigate();

  const dispatch = useDispatch();
  const { configuration } = useSelector((state) => state.configuration);
  const { t } = useTranslation();

  const { values, errors, handleChange, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocation } = useFormValidationsGeneric(
      () => configurationCallback(),
      configuration,
      schemaValidateConfigurationsList
    );

  const configurationCallback = () => {
    debugLogPages(':: NewConfigurations, configurationCallback, values', { values }); 

    let valuesSubmit = { ...values };

    valuesSubmit.deleted = false;

    debugLogPages(':: NewConfigurations, configurationCallback, valuesSubmit', { valuesSubmit }); 
    dispatch(configurationStartRegister(valuesSubmit, navigate));

  };

  debugLogPages(':: NewConfigurations', { values:values}); 
  debugLogPages(':: NewConfigurations', { errors:errors}); 

  return (
    <div>
      <NavbarIconsConfiguration page={"newConfiguration"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

            {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateConfigurationsList && schemaValidateConfigurationsList.length > 0 && (
                  schemaValidateConfigurationsList.map((techSecondary, index) => {

                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric") {
                      if (techSecondary.comparable_relation_condition === "CatalogCiius") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGeneric") {
                      return (
                        <NewCatalogLocationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeLocation}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewConfigurations;
